import { render, staticRenderFns } from "./checkJoinInfo.vue?vue&type=template&id=280203d5&scoped=true&"
import script from "./checkJoinInfo.vue?vue&type=script&lang=js&"
export * from "./checkJoinInfo.vue?vue&type=script&lang=js&"
import style0 from "./checkJoinInfo.vue?vue&type=style&index=0&id=280203d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280203d5",
  null
  
)

export default component.exports